import { Outlet } from 'react-router-dom';

import Background from '../../../components/layout/Background';
import ListenerContainer from '../../../components/util/ListenerContainer';

const Root = () => {
  return (
    <>
      <ListenerContainer />
      <Outlet />
      <Background />
    </>
  );
};

export default Root;
